import React, { useContext, useEffect } from "react"

import "../../styles/screens/screens.css"
import "../../styles/screens/general.scss"

import { Context } from "./../../provider/index"
import languageData from "../../data/language.json";

import Header from "../general/Header"
import Footer from "../general/Footer"
import Border from "../general/Border"

const LANGUAGES = [
  { label: "Nederlands", value: "nl" },
  { label: "Français", value: "fr" },
];

const LanguageScreen = () => {
  const { admin, dispatch } = useContext(Context);

  useEffect(() => {
    dispatch({ type: "option", payload: 0 });
    dispatch({ type: "maxOptions", payload: LANGUAGES.length });
    dispatch({ type: "rulesToSwitch", payload: false });
  }, []);
  
  useEffect(() => {
    dispatch({ type: "language", payload: LANGUAGES[admin.option].value });
  }, [admin.option]);

  return (
    <div className="uiContainer">
      <Header />

      <div 
        className="uiField uiFieldBorders"
        style={{width: admin.size.w > 0 ? admin.size.w : null, height: admin.size.h > 0 ? admin.size.h : null}}
      >
        <div className="pickerContainer">
          <h3 className="pickerTitle">{languageData[LANGUAGES[admin.option].value].select}</h3>

          <div className="pickerButtons">
            <div className={`pickerButtonsItem btn ${admin.activeButton == "up" ? 'active' : ''}`}>
              <img src="./images/buttons/arrowUp.png" alt="arrowUp" />
            </div>

            <h1 className="randomName">{LANGUAGES[admin.option].label}</h1>

            <div className={`pickerButtonsItem btn ${admin.activeButton == "down" ? 'active' : ''}`}>
              <img src="./images/buttons/arrowDown.png" alt="arrowDown" />
            </div>
          </div>
        </div>

        <Border/>
      </div>

      <Footer actives={[1,0,1,0]}/>
    </div>
  );
};

export default LanguageScreen;
